<span
  class="{{ bubble.class }}"
  (click)="onBubbleClick($event)"
>
  <span class="bubble-content">
    {{ bubble.showDot ? '' : (bubbleTranslationKeys[bubble.currentValue] | translate) }}
  </span>
</span>
